import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {useSubscription} from "../subscription/useSubscription";
import ideaActionsFactory from "../idea/ideaActions";
import IdeaDetailsModal from "../idea/modal/IdeaDetailsModal";
import {CentredLoader} from "../elements/Loader";
import StockData from "./data/StockData";
import StockActivity from "./activity/StockActivity";

export const defaultActivityLimit = 50;

const StockPage = ({activityLimit = defaultActivityLimit}) => {
    const history = useHistory();
    const {ideaId, orgId} = useParams();
    useSubscription("STOCK", `/ui/api/stocks/${orgId}`, 60);
    const stockDetails = useSelector(state => state.singleStock);
    const dispatch = useDispatch();
    useEffect(() => {
        if (ideaId) {
            ideaActionsFactory(dispatch).showDetail(ideaId);
        }
    }, [ideaId]);
    const onExitModal = useCallback(() => {
        if (ideaId) {
            history.replace("/stock/" + orgId);
        }
    }, [ideaId, orgId]);

    if (!stockDetails.orgId) {
        return <div style={{padding: 20}}><CentredLoader /></div>;
    }

    const ideaActions = ideaActionsFactory(dispatch);

    return <div>
        <StockData stockDetails={stockDetails}/>
        <StockActivity stockDetails={stockDetails} activityLimit={activityLimit} ideaActions={ideaActions}/>
        <IdeaDetailsModal onExit={onExitModal}/>
    </div>;
};

export default StockPage;
